export default __webpack_public_path__ + "static/codeplatform-ai-1-134eac61e975ac555779c63b4d7ab1e7.png";